import { INewOpenMarketProduct } from '../../../interfaces/OpenMarketProduct.interfaces';
import { customAxios } from '../../common/customAxios';

export const getNewOpenMarketProduct = (): Promise<INewOpenMarketProduct> => {
  return customAxios.get(`/user-sell-tractors/new-tractor`);
};
